import Axios from 'axios';
import { Toast } from 'vant';
import md5 from '../utils/md5';
import Tool from './../common/tool';
import * as AppMethod from '../utils/appMethod';
// 接口前缀
const setToken = () => {
  // token : bb951958970f59c51f1b77232843ab01
  const token = window.localStorage.getItem('dpm_grade_NativeId') || Tool.getStorage('dpm_userinfo').token || 'e2cc41eb476536e97e8c7b75de24e90e'
  return token ? { 'token': token } : {};
};
const setOrg = () => {
  // org : 21188075522202009676dfd1c0524d42
  const org = window.localStorage.getItem('dpm_grade_org') || '21188075522202009676dfd1c0524d42'
  AppMethod.zgLog(`获取org3333:${org}`)
  return org ? { 'org': org } : {};
};
const setAccountRole = () => {
  const accountRole = window.localStorage.getItem('accountRole')
  AppMethod.zgLog(`获取accountRole:${accountRole}`)
  return accountRole ? { 'accountRole': accountRole } : {};
};
// axios 配置实例
const getAxiosInstance = () => {
  const davinciKey = 'davinci.grade'
  const nonceStr = new Date().getTime() % 100000
  const sign = md5(nonceStr + davinciKey)
  const instance = Axios.create();

  instance.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    ...setAccountRole(),
    ...setOrg(),
    ...setToken()
  };
  instance.defaults.timeout = 15000;
  instance.interceptors.request.use(config => {
    const token = setToken();
    const org = setOrg();
    const accountRole = setAccountRole();
    let { headers } = config;
    headers = {
      nonceStr: nonceStr,
      sign: sign,
      ...accountRole,
      ...org,
      ...token,
      ...headers,
    };
    return {
      ...config,
      headers: headers,
      params: {
        // 此处注意，你的`params`应该是个对象，不能是其他数据类型
        ...(config.params || {})
        // ts: +new Date()
      }
    };
  });
  instance.interceptors.response.use(
    response => {
      if (response && response.data) {
        let msg = response.data.info || response.data.msg || response.data.message;
        if (response.data.code == 200) {
          return Promise.resolve(response.data);
        } else if (response.data.code == 401) {
          return Promise.reject(response);
        } else if (response.data.code == '000') {
          Toast('请登录！');
          AppMethod.sessionInvalid()
          return Promise.reject(response);
        } else if (response.data.code == 500) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.data.code == 400) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.data.code == 401) {
          Toast(response.data.message);
          return Promise.reject(response);
        } else if (response.header.filecode == '10200') {
          return Promise.resolve(response);
        } else {
          Toast(msg)
          return Promise.reject(response);
        }
      } else {
        return Promise.reject('response 不存在');
      }
    },
    error => {
      console.log('-- error --');
      console.log(error);
      console.log('-- error --');
      Toast('请求超时！');
      AppMethod.zgLog(`请求错误：${error}`)
      return Promise.reject({
        msg: error
      });
    }
  );
  return instance;
};
// 获取一个 Ajax 实例
const GetAxios = () => {
  const instance = getAxiosInstance();
  const request = config => {
    return new Promise((resolve, reject) => {
      instance
        .request(config)
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  // Ajax 实体
  const Ajax = {
    get: function (url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'GET',
          url: url,
          params: data
        })
      );
    },
    del: function (url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'DELETE',
          url: url,
          params: data
        })
      );
    },
    post: function (url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'POST',
          url: url,
          data: data
        })
      );
    },
    put: function (url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'PUT',
          url: url,
          data: data
        })
      );
    },
    head: function (url, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'HEAD',
          url: url
        })
      );
    },
    options: function (url, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'OPTIONS',
          url: url
        })
      );
    },
    patch: function (url, data = {}, config = {}) {
      return request(
        Object.assign({}, config, {
          method: 'PATCH',
          url: url,
          data: data
        })
      );
    }
  };

  return Ajax;
};

export const Ajax = GetAxios();
export default GetAxios;
